import React from "react";
import styles from "./MTabs.module.css";

interface TabOption {
  value: string;
  label: string;
}

interface MTabsProps<T extends string> {
  activeTab: T;
  tabs: TabOption[];
  onTabChange: (tab: T) => void;
  disabled?: boolean;
  /** "outline" (default) — indigo-outlined track, active tab filled solid
   *  indigo. "pill" — gray track with a floating white pill for the active
   *  tab (soft shadow, indigo text), matching Figma node 259:46895. */
  variant?: "outline" | "pill";
}

export const MTabs = <T extends string>({
  activeTab,
  tabs,
  onTabChange,
  disabled = false,
  variant = "outline",
}: MTabsProps<T>) => {
  const isPill = variant === "pill";
  return (
    <div
      className={`${styles.tabsContainer} ${
        isPill ? styles.pillContainer : ""
      }`}
    >
      {tabs.map((tab, index) => (
        <button
          key={tab.value}
          type="button"
          disabled={disabled}
          onClick={() => onTabChange(tab.value as T)}
          className={`${styles.tab} ${isPill ? styles.pillTab : ""} ${
            activeTab === tab.value ? styles.active : ""
          } ${index === 0 ? styles.firstTab : ""} ${
            index === tabs.length - 1 ? styles.lastTab : ""
          } ${disabled ? styles.disabled : ""}`}
        >
          <span className={styles.tabText}>{tab.label}</span>
        </button>
      ))}
    </div>
  );
};

export default MTabs;
